export const FAQS = [
  {
    q: "Is Kostaja accepting new clients in 2026?",
    a: "Kostaja's remaining 2026 project capacity is currently allocated. Applications are open for 2027 projects, and waitlisted businesses may be considered if an earlier opening becomes available.",
  },
  {
    q: "How does the Kostaja waitlist work?",
    a: "Businesses can submit their project for review. Applications are considered based on project fit, requirements, timing, and available capacity rather than strictly by submission date. Selected applicants will be contacted about next steps.",
  },
  {
    q: "Can I still contact Kostaja about a 2026 project?",
    a: "Yes. Submit the project through the waitlist. If earlier capacity becomes available, suitable waitlisted projects may be contacted.",
  },
  {
    q: "How does Kostaja price work?",
    a: "Fixed price where possible. Larger projects use clear starting prices and a written scope so you can decide before you commit.",
  },
  {
    q: "Do I need a brand before a website?",
    a: "Not always. If both need work, the Brand and Website packages handle them together. If only one is the problem, we focus there.",
  },
  {
    q: "Who actually does the work?",
    a: "Kostaja is shaped by commercial judgment. The person you meet on the strategy call is the person making the decisions about your project.",
  },
  {
    q: "What if I do not know what I need?",
    a: "Book a Strategy Call. The whole point of the call is to figure that out before you spend more money.",
  },
  {
    q: "How does payment work?",
    a: "Smaller fixed-scope services use Stripe Payment Links where available. Larger projects use a deposit, then a balance at delivery. Deposits are not sold as standalone services.",
  },
  {
    q: "Do you offer ongoing support?",
    a: "Yes. Monthly Marketing Support and Google Business Profile Growth Support are designed for ongoing work without lock-in tricks.",
  },
];
